import React from "react";
import { MDBRow } from "mdb-react-ui-kit";
import CommonViewLayout from "./CommonViewLayout";
import usePermissionForPages from "../../../Hooks/usePermissionForPages"; 

const Payment = () => {
  usePermissionForPages(['PaymentPortal'], '/portal/home');
  const paymentFilters = (
    <MDBRow>
      {/* Placeholder for future filters */}
    </MDBRow>
  );

  return (
    <CommonViewLayout
      headerTitle="Payments"
      filters={paymentFilters}
      iconName="credit-card"
    >
      {/* Content will go here */}
    </CommonViewLayout>
  );
};

export default Payment;
